import React from 'react';
import type { Sentiment } from '@/types/analysis';

interface SentimentCardProps {
  sentiment: Sentiment;
}

export const SentimentCard: React.FC<SentimentCardProps> = ({ sentiment }) => {
  const getSentimentColor = (label: string) => {
    const lowerLabel = label.toLowerCase();
    if (lowerLabel.includes('positive')) return 'text-green-600 bg-green-500';
    if (lowerLabel.includes('negative')) return 'text-red-600 bg-red-500';
    return 'text-gray-600 bg-gray-500';
  };

  const getSentimentIcon = (label: string) => {
    const lowerLabel = label.toLowerCase();
    if (lowerLabel.includes('positive')) return 'sentiment_satisfied';
    if (lowerLabel.includes('negative')) return 'sentiment_dissatisfied';
    return 'sentiment_neutral';
  };

  const score = Math.round(sentiment.score * 100);
  const [textColor, bgColor] = getSentimentColor(sentiment.label).split(' ');

  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-700">Sentiment Analysis</h4>
        <span className={`material-symbols-outlined text-2xl ${textColor}`}>
          {getSentimentIcon(sentiment.label)}
        </span>
      </div>
      <div className="flex items-end space-x-2 mb-2">
        <span className="text-5xl font-extrabold text-gray-900">{score}</span>
        <span className="text-2xl font-semibold text-gray-400">/100</span>
      </div>
      <p className="text-sm text-gray-500 mb-4">{sentiment.label}</p>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div 
          className={`h-2.5 rounded-full ${bgColor} transition-all duration-500`}
          style={{ width: `${score}%` }}
        />
      </div>
      {sentiment.confidence && (
        <p className="text-xs text-gray-400 mt-2">
          Confidence: {Math.round(sentiment.confidence * 100)}%
        </p>
      )}
    </div>
  );
};

